<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.titulo"
          label="Título do relatório administrativo"
        ></v-text-field>
      </v-col>
      <v-col
        v-if="isFullAdmin || (config.verContrato && groupsConfig.verContrato)"
      >
        <ComboboxContratoByUser
          :filter="payload"
          :user="user.usuarioId"
        ></ComboboxContratoByUser>
      </v-col>

      <v-col sm="1" class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="save()">
          <span>Finalizar</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="payload.inicioString"
          v-mascara="'##/##/#### ##:##'"
          label="Início"
          placeholder="00/00/0000 00:00"
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="payload.fimString"
          v-mascara="'##/##/#### ##:##'"
          label="Fim"
          placeholder="00/00/0000 00:00"
        ></v-text-field>
      </v-col>

      <v-col sm="2">
        <v-text-field
          v-model="payload.horas"
          label="Horas Correspondentes"
          placeholder="0"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>

        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              label="Descrição do relatório administrativo"
              required
              v-model="payload.descricao"
            ></v-textarea>
          </v-col>
        </v-tab-item>

        <v-tab-item>
          <v-col>
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.arquivos"
              >
              </v-file-input>
            </template>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import ComboboxContratoByUser from "@/modules/contratos/components/ComboboxByUser.vue";

export default {
  components: {
    AppCityHeader,
    ComboboxContratoByUser,
  },
  data() {
    return {
      payload: {
        arquivos: [],
        descricao: "",
        inicioString: null,
        fimString: null,
        municipioId: this.$route.params.id,
        titulo: "",
        contratos: {},
      },
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading", "setAnalistaMunicipio", "setADMunicipio"]),
    save() {
      if (!this.payload.inicioString) {
        this.$notification.error("O início deve estar preenchido");
      } else if (!this.payload.fimString) {
        this.$notification.error("O fim deve estar preenchido");
      } else if (!this.payload.horas) {
        this.$notification.error(
          "As horas correspondentes devem estar preenchidas"
        );
      } else {
        this.setLoading(true);
        let formData = new FormData();

        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }

        formData.append("descricao", this.payload.descricao);
        formData.append("municipioId", this.payload.municipioId);
        formData.append("titulo", this.payload.titulo);
        formData.append("inicioString", this.payload.inicioString);
        formData.append("fimString", this.payload.fimString);
        formData.append("horas", this.payload.horas);
        formData.append("contratoId", this.payload.contratos.contratoId);

        administrativeReportAPI
          .create(formData)
          .then((resp) => {
            this.$notification.success(
              "Relatório Administrativo salvo com sucesso"
            );
            this.$router.push(
              "/cidade/" +
                this.payload.municipioId +
                "/relatorio-administrativo"
            );
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao salvar relatório administrativo");
          });
      }
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAuthenticated",
      "isAT",
      "isGov",
      "user",
      "isFullAdmin",
      "config",
      "groupsConfig",
    ]),
  },
  created() {
    if (this.estado === "SC" || this.estado === "MS" || this.estado === "SP") {
      this.payload.descricao = `Apurar mensalmente a efetividade e eficácia das ações realizadas nos municípios analisando potencial de melhoria do escopo das ${
        this.isAT ? "iniciativas" : this.isGov ? "fases" : "soluções"
      }.`;
      this.payload.titulo = `Diagnóstico e monitoramento geral da aplicação das ${
        this.isAT ? "iniciativas" : this.isGov ? "fases" : "soluções"
      }`;
    }
  },
};
</script>
